// extracted by mini-css-extract-plugin
export default {"tooltip":"User_tooltip__GpsYl","baseBadge":"User_baseBadge__MXnbg","active":"User_active__fugnd","badgeRow":"User_badgeRow__sQQZY","adminLink":"User_adminLink__l6RwE"};